import './styles.css';
import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './app/app';
import { ApolloProvider } from './app/providers/apollo-provider';
import { environment } from './environments/environment';
import { initGtm } from './app/shared/utils/gtm';
import { getAnalyticsMode } from './app/shared/utils/analytics';

if (environment.sentry.enabled) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    release: environment.version,
    sendDefaultPii: true,
  });
}

console.log(`iQD Budget Calculator ${environment.version}`);

// Only the standalone site loads its own container. When embedded, events are
// bridged to the host page's container instead, so that the calculator shares
// the host's GA4 client id, session and consent state rather than starting a
// competing (and unconsented) measurement context inside the iframe.
if (getAnalyticsMode() === 'gtm') {
  initGtm({ id: environment.gtm.id, enabled: environment.gtm.enabled });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <BrowserRouter>
      <ApolloProvider>
        <App />
      </ApolloProvider>
    </BrowserRouter>
  </StrictMode>,
);
